<i18n lang="json">
{
  "en": {
    "showMore": "Show More",
    "showLess": "Show Less"
  },
  "fr": {
    "showMore": "Montre plus",
    "showLess": "Montre moins"
  }
}
</i18n>
<template>
  <h2 class="subtitle-4 mb-6 font-semibold not-italic">{{ title }}</h2>
  <div class="flex flex-wrap gap-6 sm:gap-5" :class="collapsedClass">
    <nuxt-link
      v-for="keyword in props.keywordsList"
      :key="keyword.slug!"
      class="inline-block px-5 py-2 rounded-full font-semibold not-italic text-base transition ease-in duration-200 bg-primary-50 hover:border-primary border-2 text-center cursor-pointer"
      :class="[isSelectedClass(keyword.slug!)]"
      :to="{
        name: buttonRouteName.value,
        params: { keyword: keyword.slug, place: props.basePath?.split('/') }
      }"
    >
      {{ keyword.displayValue }}
    </nuxt-link>
  </div>
  <button
    class="text-primary hover:text-highlight text-base font-semibold py-3 px-0 underline"
    @click="collapsed = !collapsed"
  >
    {{ showMoreOrLess }}
  </button>
</template>
<script setup lang="ts">
import type { Place, PlaceSeo } from '~/types/api'
import type { IKeywordSearch } from '~/types/search/keyword-search'

const props = defineProps<{
  place: Place
  seo: PlaceSeo | null
  basePath?: string
  keywordsList: IKeywordSearch[]
}>()
const { t } = useI18n()

const title = computed(() => {
  return props.seo?.commonSearchTitle ?? ''
})

const collapsed = ref(true)

const route = useRoute()
function isSelectedClass(slug: string) {
  return slug === (route.params?.keyword as string) ? 'border-primary' : 'border-transparent'
}

const collapsedClass = computed(() => {
  return collapsed.value ? 'max-h-44 overflow-hidden' : ''
})

const showMoreOrLess = computed(() => {
  return collapsed.value ? t('showMore') : t('showLess')
})

const buttonRouteName = computed(() =>
  props.basePath ? 'rvs-for-sale-keyword-location-place' : 'rvs-for-sale-keyword'
)
</script>
